module.exports = __webpack_public_path__ + "/images/shop/caris-cockpit/hsn_tsn2.jpg";